import React from "react";
import PropTypes from "prop-types";

export default function Share(props) {
  return (
    <svg
      className={props.className}
      width={props.width}
      height={props.height}
      viewBox={`0 0 ${props.width} ${props.height}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22.2159 3.99994C22.2159 5.79492 20.6948 7.25006 18.8182 7.25006C16.9417 7.25006 15.4206 5.79492 15.4206 3.99994C15.4206 2.20514 16.9417 0.75 18.8182 0.75C20.6948 0.75 22.2159 2.20514 22.2159 3.99994Z"
        fill="#3965DE"
      />
      <path
        d="M18.8182 8.00006C16.5119 8.00006 14.6365 6.20599 14.6365 3.99994C14.6365 1.79407 16.5119 0 18.8182 0C21.1246 0 23 1.79407 23 3.99994C23 6.20599 21.1246 8.00006 18.8182 8.00006ZM18.8182 1.5C17.3766 1.5 16.2047 2.62207 16.2047 3.99994C16.2047 5.37799 17.3766 6.50006 18.8182 6.50006C20.2599 6.50006 21.4318 5.37799 21.4318 3.99994C21.4318 2.62207 20.2599 1.5 18.8182 1.5Z"
        fill="#3965DE"
      />
      <path
        d="M22.2159 20.0001C22.2159 21.7949 20.6948 23.25 18.8182 23.25C16.9417 23.25 15.4206 21.7949 15.4206 20.0001C15.4206 18.2051 16.9417 16.7499 18.8182 16.7499C20.6948 16.7499 22.2159 18.2051 22.2159 20.0001Z"
        fill="#3965DE"
      />
      <path
        d="M18.8182 24C16.5119 24 14.6365 22.2059 14.6365 20.0001C14.6365 17.794 16.5119 15.9999 18.8182 15.9999C21.1246 15.9999 23 17.794 23 20.0001C23 22.2059 21.1246 24 18.8182 24ZM18.8182 17.4999C17.3766 17.4999 16.2047 18.622 16.2047 20.0001C16.2047 21.3779 17.3766 22.5 18.8182 22.5C20.2599 22.5 21.4318 21.3779 21.4318 20.0001C21.4318 18.622 20.2599 17.4999 18.8182 17.4999Z"
        fill="#3965DE"
      />
      <path
        d="M7.57963 12C7.57963 13.795 6.05834 15.2499 4.18177 15.2499C2.30538 15.2499 0.784093 13.795 0.784093 12C0.784093 10.205 2.30538 8.75006 4.18177 8.75006C6.05834 8.75006 7.57963 10.205 7.57963 12Z"
        fill="#3965DE"
      />
      <path
        d="M4.18177 15.9999C1.87562 15.9999 0 14.2061 0 12C0 9.79395 1.87562 8.00006 4.18177 8.00006C6.4881 8.00006 8.36372 9.79395 8.36372 12C8.36372 14.2061 6.4881 15.9999 4.18177 15.9999ZM4.18177 9.50006C2.74011 9.50006 1.56819 10.6219 1.56819 12C1.56819 13.3781 2.74011 14.4999 4.18177 14.4999C5.62361 14.4999 6.79554 13.3781 6.79554 12C6.79554 10.6219 5.62361 9.50006 4.18177 9.50006Z"
        fill="#3965DE"
      />
      <path
        d="M6.65024 11.5201C6.28634 11.5201 5.93296 11.339 5.74057 11.0151C5.45515 10.5361 5.63088 9.92505 6.13166 9.65094L15.8323 4.36102C16.3331 4.086 16.9719 4.25409 17.2585 4.73492C17.5439 5.21393 17.3682 5.82495 16.8674 6.09906L7.16653 11.389C7.00343 11.478 6.82578 11.5201 6.65024 11.5201Z"
        fill="#3965DE"
      />
      <path
        d="M16.3499 19.7701C16.1742 19.7701 15.9966 19.728 15.8335 19.639L6.13262 14.3491C5.63184 14.076 5.4563 13.465 5.74172 12.9849C6.02599 12.505 6.66575 12.336 7.16767 12.611L16.8685 17.9009C17.3693 18.174 17.5448 18.785 17.2594 19.2651C17.0661 19.589 16.7127 19.7701 16.3499 19.7701Z"
        fill="#3965DE"
      />
    </svg>
  );
}

Share.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number
};

Share.defaultProps = {
  className: "",
  width: 168,
  height: 168
};
